import { getEndPoint } from './getEndPoint'
export const getEducationArticlesByCategory = category =>
  getEndPoint(
    `wp/v2/health-education?per_page=100&filter[meta_key]=category&filter[meta_compare]=LIKE&filter[meta_value]=${category}`
  )
